import Toilet from "@/assets/clients/tempula/room/dhuppi/toilet.webp"
import Balcony from "@/assets/clients/tempula/room/dhuppi/balcony.webp"
import Balcony2 from "@/assets/clients/tempula/room/dhuppi/balcony-2.webp"
import Balcony3 from "@/assets/clients/tempula/room/dhuppi/balcony-3.webp"
import Balcony4 from "@/assets/clients/tempula/room/dhuppi/balcony-4.webp"
import Balcony5 from "@/assets/clients/tempula/room/dhuppi/balcony-5.webp"
import Misc1 from "@/assets/clients/tempula/room/dhuppi/misc-1.webp"
import Misc2 from "@/assets/clients/tempula/room/dhuppi/misc-2.webp"
import Misc3 from "@/assets/clients/tempula/room/dhuppi/misc-3.webp"
import Misc4 from "@/assets/clients/tempula/room/dhuppi/misc-4.webp"
import Bedrooom from "@/assets/clients/tempula/room/dhuppi.webp"
import Bedrooom2 from "@/assets/clients/tempula/room/dhuppi/bedroom-2.webp"
import Bedrooom3 from "@/assets/clients/tempula/room/dhuppi/bedroom-3.webp"
import Bedrooom5 from "@/assets/clients/tempula/room/dhuppi/bedroom-5.webp"
import Bedrooom6 from "@/assets/clients/tempula/room/dhuppi/bedroom-6.webp"


const dhuppiConfig = {
  subInfo: "3 guests · 1 bedroom · 1 bed · 1 private bathroom",
  subInfoClass: "text-xl md:text-2xl text-white font-extralight",

  sections: [
    {
      title: "Bedroom",
      images: [Bedrooom, Bedrooom2, Bedrooom3, Bedrooom5, Bedrooom6],
    },
    {
      title: "Bathroom",
      images: [Toilet],
    },
    {
      title: "Balcony",
      images: [Balcony, Balcony2, Balcony3, Balcony4, Balcony5],
    },
    {
      title: "Miscellaneous",
      images: [Misc1, Misc2, Misc3, Misc4],
    },
  ],
};

export default dhuppiConfig;
